<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-12">
        <h2 class="titulo">{{ title }} </h2>
      </div>
      <loading v-if="!showContent"></loading>
      <div class="col-md-3 col-xs-12 col-sm-12" v-for="item in items">
        <router-link :to="getUrl(item.id, item.name)" class="evento">
          <img v-if="item.image" :src="item.image"/>
          <img v-if="!item.image" src="dist/images/sem_imagem.jpg"/>
          <span>
              <i class="fa fa-calendar" aria-hidden="true"></i> {{ item.dateFinish }}
              <i class="fa fa-clock-o" aria-hidden="true"></i> {{ item.houtFinish }}
          </span>
          {{ item.name }}
        </router-link>

      </div>

    </div>
  </div>
</template>
<script type="text/javascript">
  import {get, post} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import VueRecaptcha from 'vue-recaptcha';
  import {slugify} from '../helpers/slugify';

  export default {
    components: {
      Loading,
      VueRecaptcha
    },
    data() {
      return {
        title: 'Promoções',
        showContent: false,
        promocaoId: '',
        nome: '',
        email: '',
        telefone: '',
        captcha: '',
        sitekey: window.config.RECAPTCHA_KEY,
        items: [],
        currentPromotion: false
      }
    },
    created() {
      let self = this;
      get('promotions').then(function (response) {
        self.items = response.data.result.data;
        // self.items = this.$store.getters['getSiteContent'].result.data.promocao;
        self.showContent = true;
      })
    },
    methods: {
      getUrl(id, string) {
        return '/promocao/' + id + '/' + slugify(string);
      },
      getFormContent(promoId) {
        let self = this;
      },
      setCurrentPromotion(promoId) {
        let self = this;
        this.promocaoId = promoId;
        this.currentPromotion = true;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Promotions.vue